(() => {
  const initNavigation = (root) => {
    if (!root || root.dataset.somaNavigationReady === 'true') return;

    const bar = root.querySelector('.soma-horeca-navigation__bar');
    const progress = root.querySelector('[data-soma-navigation-progress]');
    const currentLabel = root.querySelector('[data-soma-navigation-current]');
    const toggle = root.querySelector('[data-soma-navigation-toggle]');
    const menu = root.querySelector('[data-soma-navigation-menu]');
    const links = [...root.querySelectorAll('[data-soma-navigation-link]')];
    const trackedLinks = links.filter((link) => link.dataset.somaNavigationLink !== 'inicio');
    const sections = [...new Set(trackedLinks.map((link) => link.dataset.somaNavigationLink))]
      .map((id) => document.getElementById(id))
      .filter(Boolean);
    const hero = document.getElementById('inicio');

    const closeMenu = () => {
      if (!toggle || !menu) return;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Abrir navegación');
      menu.hidden = true;
      root.classList.remove('is-menu-open');
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const id = link.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (!id || !target) return;
      event.preventDefault();
      closeMenu();
      const offset = 64;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    });

    if (toggle && menu) {
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        toggle.setAttribute('aria-label', open ? 'Abrir navegación' : 'Cerrar navegación');
        menu.hidden = open;
        root.classList.toggle('is-menu-open', !open);
      });
    }

    let ticking = false;
    const update = () => {
      const scrollTop = window.scrollY;
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const ratio = scrollable > 0 ? Math.min(Math.max(scrollTop / scrollable, 0), 1) : 0;
      progress.style.transform = `scaleX(${ratio})`;

      const heroBoundary = hero
        ? hero.getBoundingClientRect().top + window.scrollY + hero.offsetHeight
        : 400;
      const heroEnd = heroBoundary - 80;
      root.classList.toggle('is-visible', scrollTop > heroEnd);
      root.classList.toggle('is-past-hero', scrollTop >= heroBoundary);

      let active = null;
      sections.forEach((section) => {
        const sectionTop = section.getBoundingClientRect().top + window.scrollY;
        if (scrollTop >= sectionTop - 140) active = section.id;
      });

      trackedLinks.forEach((link) => {
        const isActive = link.dataset.somaNavigationLink === active;
        link.classList.toggle('is-active', isActive);
        if (isActive) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });

      if (active && currentLabel) {
        const activeLink = trackedLinks.find((link) => link.dataset.somaNavigationLink === active);
        if (activeLink) {
          currentLabel.textContent = activeLink.dataset.somaNavigationLabel || activeLink.textContent.trim();
        }
      }

      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
    root.dataset.somaNavigationReady = 'true';
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-soma-navigation]').forEach(initNavigation);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
